<template lang="html">
  <div class="body">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      @load="loadMore"
    >
      <van-cell
        v-for="voucherCard in voucherCards" :key="voucherCard.id"
      >
      <!-- @click="voucherCardDetail(voucherCard.id)" -->
        <van-skeleton
          avatar
          avatar-shape="square"
          avatar-size="50"
          :row="3"
          :loading="skeletonLoading"
        >
          <voucher-card-detail
            :list-mode="true"
            :voucher-card-data="voucherCard"
            @voucher-update-success="voucherUpdateSuccess"
          />
        </van-skeleton>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import Vue from 'vue'
import { List } from 'vant'
import { Cell, CellGroup } from 'vant'
import { Skeleton } from 'vant'
import VoucherCardDetail from './voucher-card-detail.vue'
// import EpisodeCard from '../../episode-card.vue'
Vue.use(List)
Vue.use(Cell).use(CellGroup)
Vue.use(Skeleton)
export default {
  name: 'voucher-card-list',
  components: {
    VoucherCardDetail,
    // EpisodeCard
  },
  data () {
    return {
      skeletonLoading: false,
      loading: false,
      finished: false,
      finishedText: '没有更多了',
      voucherCards: [],
      next: ''
    }
  },
  props: {
    slug: {
      type: String,
      default: ''
    },
    buyer: {
      type: String,
      default: 'me'
    }
  },
  watch: {
    slug (newVal, oldVal) {
      window.console.log("watch slug")
      window.console.log(newVal)
      window.console.log(oldVal)
      if (newVal && newVal != oldVal) {
        this.getVoucherCards()
      }
    }
  },
  methods: {
    loadData () {
      this.getVoucherCards()
    },
    getVoucherCards () {
      let that = this
      let params = { slug: that.slug, active: true }
      window.console.log("开始获得VoucherCards...")
      that.$api.voucher.list(params).then(res => {
        window.console.log("获得VoucherCards")
        window.console.log(res.data)
        that.next = res.data.next
        that.loading = false
        if (res.data.next == null) {
          that.finished = true
        }
        if (that.limit > 0) {
          that.voucherCards = res.data.results.slice(0, that.limit)
        } else {
          that.voucherCards = res.data.results
        }
        return
      })
    },
    loadMore () {
      window.console.log("loadMore...")
      let that = this
      if (that.next) {
        that.loading = true
        let url = that.next.split('/api/')[1] // 截掉前面的域名和 /api/ 部分
        that.$api.normal.load(url).then(res => {
          that.voucherCards = that.voucherCards.concat(res.data.results)
          that.next = res.data.next
          that.loading = false
          if (that.next == null) {
            that.finished = true
          }
        })
      } else {
        if (that.next === null) {
          that.finished = true
        }
      }
    },
    voucherCardDetail (voucherCardId) {
      this.$router.replace({
        name: 'VoucherCardDetailPage',
        params: {
          vouchercardId: voucherCardId
        }
      })
    },
    voucherUpdateSuccess: function () {
      window.console.log("voucherUpdateSuccess 4")
      // const voucherId = e.voucherId
      this.loadData()
    }
  },
  mounted: function () {
    
  }
}
</script>

<style lang="css" scoped>
.body {
  padding-bottom: 100px;
}
</style>
